<template>
  <v-navigation-drawer app v-model="drawerInternal" color="#EBEBEB">
    <v-list nav dense class="navigation-list">
      <v-subheader>Menu</v-subheader>

      <router-link v-for="(l,i) in mainMenuLinks" :key="`main-link-${i}`" :to="{name: l.routeName}">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title><v-icon class="pr-1">{{ l.icon }}</v-icon>{{l.title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>

      <template v-if="getNumberOfLeagues > 1">
        <v-subheader>League Picker</v-subheader>

        <router-link v-for="(leagueId,i) in getUserLeagueIds" :key="`league-picker-link-${i}`" :to="{name: routes.LEAGUE, params: {leagueId: leagueId}}">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{i+1}}. {{ getUserLeagues[leagueId]  }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>

      </template>

<!--      <v-icon class="pr-1">mdi-shield</v-icon>-->
      <!-- end league-select context-->

      <template v-if="getLeagueId">
        <v-subheader >{{getLeague.name}}</v-subheader>

        <template v-for="(l,i) in leagueLinks">
          <router-link
              v-if="l.requiresTrue == null ||  l.requiresTrue()"
              :key="`league-link-${i}`"
              :to="{name: l.routeName, params: {leagueId: getLeagueId}}"
          >
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title><v-icon class="pr-1">{{ l.icon }}</v-icon>{{l.title}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </template>

      </template>
      <!--      end league context-->
      <template v-if="isGlobalAdmin">
        <v-subheader >Global Admin</v-subheader>
        <router-link v-for="(l,i) in globalAdminLinks" :key="`admin-link-${i}`" :to="{name: l.routeName}">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><v-icon class="pr-1">{{ l.icon }}</v-icon>{{l.title}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </template>
      <!--      end admin context-->

      <template>
        <v-subheader>User</v-subheader>
        <router-link :to="{name: routes.MY_USER}">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><v-icon class="pr-1">mdi-account</v-icon>My User</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </template>

    </v-list>
  </v-navigation-drawer>
</template>
<script setup lang="ts">
import * as routes from '@/router/route-names'
import {computed, defineEmits, defineProps,} from 'vue'
import {useStore} from '@/store/store'

const store = useStore()
const emit = defineEmits(['update-drawer'])

const props = defineProps({
  drawer: {
    type: Boolean,
    required: false,
  }
})

interface LinkObject {
  title: string;
  routeName: string;
  icon: string;
  requiresTrue?: () => boolean;
}

const mainMenuLinks : LinkObject[] = [
  {title: 'Home', routeName: routes.HOME, icon: 'mdi-home', },
  {title: 'Rules', routeName: routes.RULES, icon: 'mdi-format-list-checks', },
]
const leagueLinks : LinkObject[] = [
  {title: 'Admin', routeName: routes.LEAGUE_ADMIN_QUESTIONS, icon: 'mdi-shield', requiresTrue: ()=> isLeagueAdmin.value},
  {title: 'Dashboard', routeName: routes.LEAGUE, icon: 'mdi-view-dashboard', },
  {title: 'Detailed Picks', routeName: routes.LEAGUE_PICKS, icon: 'mdi-table', },
  {title: 'Entries', routeName: routes.LEAGUE_ENTRIES, icon: 'mdi-account-group', },
  {title: 'Hall of Champions', routeName: routes.LEAGUE_CHAMPS, icon: 'mdi-trophy', },
]

const globalAdminLinks : LinkObject[] = [
  {title: 'Global Admin', routeName: routes.GLOBAL_ADMIN, icon: 'mdi-shield', },
]

const getLeague = computed(() => {
  return store.getters.getLeague
})

const getLeagueId = computed(() => {
  return store.getters.getLeagueId
})

const isGlobalAdmin = computed(() => {
  return store.getters.isGlobalAdmin
})

const getUserLeagueIds = computed(() => {
  return store.getters.getUserLeagueIds
})

const getNumberOfLeagues = computed(() => {
  return store.getters.getNumberOfLeagues
})

const getUserLeagues = computed(() => {
  return store.getters.getUserLeagues
})

const isLeagueAdmin = computed(() => {
  if (!getLeague.value) return false
  return getLeague.value.isAnAdmin
})

const drawerInternal = computed({
  get() {
    return props.drawer
  },
  set(newValue) {
    emit('update-drawer', newValue)
  }
})


</script>
<style lang="scss" scoped>
.navigation-list {
  a {
    text-decoration: none;

    :hover {
      background-color: darken(#EBEBEB, 10%);
    }
  }
}
</style>
